export enum Addons {
  PURCHASE = 'Скупка',
  PURCHASE_EXCHANGE = 'Скупка по принципу обмена',
}

export const getAddon = (addon: keyof typeof Addons): string => Addons[addon];
